import { Container, type ContainerProps } from "@octopus-energy/coral/atoms"
import { PageStepNumber } from "./components/atoms/PageStepNumber"
import { PageStepTitle } from "./components/atoms/PageStepTitle"
import { PageSubtitle } from "./components/atoms/PageSubtitle"
import { PageTitle } from "./components/atoms/PageTitle"

type Props = {
    header?: boolean
} & ContainerProps

export function Page({ children, maxWidthPreset = "lg", theme = "base500", ...props }: Props) {
    return (
        <Container
            theme={theme}
            {...props}
        >
            <Container
                maxWidthPreset={maxWidthPreset}
                marginY="none"
                marginX="auto"
                padding={{ base: "md", md: "xxl" }}
            >
                {children}
            </Container>
        </Container>
    )
}

Page.Title = PageTitle
Page.Subtitle = PageSubtitle
Page.StepTitle = PageStepTitle
Page.StepNumber = PageStepNumber
